import React from 'react';
import { InfoTooltip } from './InfoTooltip';
interface FormFieldProps {
  label: string;
  required?: boolean;
  tooltip?: string;
  children: React.ReactNode;
}
export function FormField({
  label,
  required = false,
  tooltip,
  children
}: FormFieldProps) {
  return <div className="mb-4" data-id="element-830">
      <div className="flex items-center mb-1" data-id="element-831">
        <label className="block text-sm font-medium text-gray-700" data-id="element-832">
          {label} {required && <span className="text-red-500" data-id="element-833">*</span>}
        </label>
        {tooltip && <InfoTooltip content={tooltip} data-id="element-834" />}
      </div>
      {children}
    </div>;
}